import * as React from "react";

import { useMenuButtonStyles_unstable } from "@fluentui/react-components";

import type { AppMenuButtonProps } from ".";
import { useAppMenuButton } from "./useAppMenuButton";
import { renderAppMenuButton } from "./renderAppMenuButton";

export const AppMenuButton = React.memo(
  React.forwardRef<
    HTMLButtonElement & { dismissMenu?: () => void },
    AppMenuButtonProps
  >((props, ref) => {
    const state = useAppMenuButton(props, ref);

    useMenuButtonStyles_unstable(state);

    return renderAppMenuButton(state);
  })
);

AppMenuButton.displayName = "next/AppMenuButton";
